import { render, staticRenderFns } from "./infizierendegefuehle.vue?vue&type=template&id=4f2c05c8&scoped=true&"
import script from "./infizierendegefuehle.vue?vue&type=script&lang=js&"
export * from "./infizierendegefuehle.vue?vue&type=script&lang=js&"
import style0 from "./infizierendegefuehle.vue?vue&type=style&index=0&id=4f2c05c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2c05c8",
  null
  
)

export default component.exports